import {Component, Input, OnInit} from '@angular/core';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'mensagem-bloqueio',
  templateUrl: './mensagem-bloqueio.component.html',
  styleUrls: ['./mensagem-bloqueio.component.scss']
})
export class MensagemBloqueioComponent implements OnInit {
  @Input() bloqueado;
  constructor() { }

  ngOnInit() {
  }

}
